import React from "react";

interface NoticeModalProps {
  isOpen: boolean;
  onClose: () => void;
  src?: string;
  title?: string;
}

export const NoticeModal: React.FC<NoticeModalProps> = ({
  isOpen,
  onClose,
  src,
  title,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl w-full max-w-lg mx-4">
        <div className="flex justify-end items-center pt-4 px-4">
          <button onClick={onClose} className="text-gray-500">
            닫기
          </button>
        </div>
        <div className="w-full h-[90vh] rounded-b-xl overflow-hidden">
          <iframe
            src={src}
            title={title}
            className="w-full h-full transform scale-[0.9] origin-top-left"
            style={{
              width: "calc(100% / 0.9)",
              height: "calc(100% / 0.9)",
            }}
          />
        </div>
      </div>
    </div>
  );
};
